import React from 'react';
import { Text } from 'components/core/Typography';
import { Image } from 'components/core/Image';

import openDoorImage from 'assets/images/icons/opennowdoor.png';

import './OpenNow.scss';

export default function OpenNow() {
	return (
		<div className="open-now">
			<Text
				color="white"
				className="open-now-text"
			>
				<Image
					src={openDoorImage}
					className="open-now-image"
					alt="open door"
				/>
				This facility is currently open.
			</Text>
		</div>
	);
}
